import React, { useMemo } from 'react'
import { EmailConfig } from './EmailDesignSettings'
import { FormattedMessage } from 'react-intl'
import { TEMPLATE_MESSAGES as M } from '../templateMessages'
import { useEmailPreviewLogo } from '../../../helpers/emailLogo'

interface EmailPreviewProps {
    config: EmailConfig
    bodyHtml: string
}

export const EmailPreview: React.FC<EmailPreviewProps> = ({ config, bodyHtml }) => {
    const { styles } = config
    const withPreviewLogo = useEmailPreviewLogo()

    // We construct a complete HTML document string to mimic what the backend might send
    // Using inline styles for email compatibility simulation
    const previewContent = useMemo(() => {
        return `
      <div style="font-family: ${styles.fontFamily}; max-width: 600px; margin: 0 auto; background-color: #f8f9fa;">
        <!-- Body -->
        <div style="background-color: #ffffff; padding: 30px; color: #333333; line-height: 1.6;">
          ${bodyHtml ? withPreviewLogo(bodyHtml) : '<p style="color: #999;">Start typing in the editor...</p>'}
        </div>
      </div>
    `
    }, [config, bodyHtml, withPreviewLogo])

    return (
        <div className='email-preview-container border rounded bg-light p-3 h-100 overflow-auto'>
            <div className='d-flex justify-content-between align-items-center mb-2'>
                <small className='text-muted text-uppercase fw-bold'><FormattedMessage {...M.previewLive} /></small>
                <div className='badge bg-warning text-dark'><FormattedMessage {...M.previewDesktop} /></div>
            </div>

            <div
                className='email-canvas bg-white shadow-sm mx-auto'
                style={{ maxWidth: '640px', minHeight: '400px' }}
                dangerouslySetInnerHTML={{ __html: previewContent }}
            />
        </div>
    )
}
